/* 
  命题教师评价
*/
import request from "@/utils/request";

//获取命题教师评价页面参数
export function getParam() {
  return request({
    url: "/propositionteacher/propositionTchEvaluate/getParam",
    method: "get"
  });
}

//获取命题教师评价分页列表
export function getPropositionTchEvaluate(params) {
  return request({
    url: "/propositionteacher/propositionTchEvaluate/getPropositionTchEvaluate",
    method: "get",
    params
  });
}

// 删除信息
export function deleteInfo(data) {
  return request({
    url: "/propositionteacher/propositionTchEvaluate/deleteInfo",
    method: "post",
    data
  });
}